import { retrieve } from 'redevConfig'

const list = (retrieve && retrieve.list) || ''
const retrievePage = list ? require(`redevelopment/outputManage/retrieve/${list.templateName}`) : require('./view/retrieve.html')
export default {
    base: {
        state: 'outputManage.stock.retrieve',
        config: {
            url: '/retrieve',
            abstract: true,
            template: '<div ui-view></div>',
            title: '发票收回',
            default: 'outputManage.stock.retrieve.list',
        },
    },
    list: {
        state: 'outputManage.stock.retrieve.list',
        config: {
            url: '/list',
            template: retrievePage,
            controller: 'retrieveCtrl',

        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/retrieve/routers.js